import api from '../../plugins/api';

const onlineVehicleRegistration = (chunkId) => {
  return api.post('/api/bank/online-vehicle-registration', { chunkId });
};

export default onlineVehicleRegistration;
